<script>
  import { writable } from "svelte/store";
  import Modal, { bind } from "svelte-simple-modal";
  import Gallery from "./Gallery.svelte";
  import Home from "./Home.svelte";
  import Work from "./Work.svelte";
  import Exhibitions from "./Exhibitions.svelte";
  import About from "./About.svelte";
  import { route, link } from "./router";

  const modal = writable(null);
  const openGallery = (album, context = null) =>
    modal.set(bind(Gallery, { album, context }));

  // The browser restores the previous scroll position on reload/navigation,
  // which lands visitors mid-page; always start routes at the top instead.
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);

  let segments;
  $: segments = $route.split("/");

  let menuOpen = false;
  const closeMenu = () => {
    menuOpen = false;
  };
  const onNavLink = (e) => {
    closeMenu();
    link(e);
  };
  $: $route, closeMenu();
  $: $route, modal.set(null);

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };

  window.addEventListener("resize", appHeight);
  window.addEventListener("orientationchange", appHeight);
  appHeight();
</script>

<main>
  <div class="nav">
    <a class="nav-name" href="/" on:click={onNavLink}>JV</a>
    <button
      class="menu-button"
      on:click={() => (menuOpen = !menuOpen)}
      aria-label="Menu">&#9776;</button
    >
    <div class="nav-links" class:open={menuOpen}>
      <a href="/work" on:click={onNavLink}>Work</a>
      <a href="/exhibitions" on:click={onNavLink}>Exhibitions</a>
      <a href="/about" on:click={onNavLink}>About</a>
      <a href="mailto:jv@jasminevenes.com" on:click={closeMenu}>Contact</a>
      <a
        href="https://www.instagram.com/jv.folly/"
        target="_new"
        on:click={closeMenu}>Instagram</a
      >
    </div>
  </div>

  <Modal
    show={$modal}
    styleWindow={{
      width: "100vw",
      height: "100vh",
      margin: 0,
      borderRadius: 0,
      background: "none",
    }}
    styleBg={{
      background: "rgba(250, 249, 247, 0.6)",
      backdropFilter: "blur(30px)",
      "-webkit-backdrop-filter": "blur(30px)",
    }}
    styleWindowWrap={{
      margin: 0,
    }}
    styleContent={{ height: "100%", padding: 0, maxHeight: "100%" }}
    styleCloseButton={{
      cursor: "pointer",
      borderRadius: 0,
      top: 0,
      right: 0,
      width: "55px",
      height: "55px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  />

  {#if segments[0] === "work"}
    <Work series={segments[1] || null} {openGallery} />
  {:else if segments[0] === "exhibitions"}
    <Exhibitions />
  {:else if segments[0] === "about"}
    <About />
  {:else}
    <Home />
  {/if}
</main>

<style>
  .nav {
    background-color: var(--paper);
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--hairline);
    position: relative;
  }
  .nav .nav-name {
    font-family: "Cormorant Garamond", serif;
    font-size: 1.4rem;
    color: #1a1a1a;
    text-decoration: none;
  }
  .nav .menu-button {
    display: none;
    background: none;
    border: none;
    font-size: 1.3rem;
    color: #555;
    cursor: pointer;
    padding: 0;
  }
  .nav .nav-links {
    display: flex;
    gap: 2rem;
  }
  .nav .nav-links a {
    color: #777;
    font-size: 0.9rem;
    text-decoration: none;
  }
  .nav .nav-links a:hover {
    color: #111;
  }

  @media (max-width: 800px) {
    .nav .menu-button {
      display: block;
    }
    .nav .nav-links {
      display: none;
    }
    .nav .nav-links.open {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.25rem;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background-color: var(--paper);
      border-bottom: 1px solid var(--hairline);
      padding: 1.25rem 0;
      z-index: 10;
    }
  }
</style>
